"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkResponse = exports.buildOptions = exports.ServiceHttpResponseError = exports.ExtensibleError = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable max-classes-per-file */
var ExtensibleError = /*#__PURE__*/function (_Error) {
  (0, _inherits2["default"])(ExtensibleError, _Error);

  var _super = _createSuper(ExtensibleError);

  function ExtensibleError(message) {
    var _this;

    var additionalInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, _classCallCheck2["default"])(this, ExtensibleError);
    _this = _super.call(this, message);
    _this.name = _this.constructor.name;
    _this.additionalInfo = additionalInfo;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace((0, _assertThisInitialized2["default"])(_this), _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }

    return _this;
  }

  return ExtensibleError;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));

exports.ExtensibleError = ExtensibleError;

var ServiceHttpResponseError = /*#__PURE__*/function (_ExtensibleError) {
  (0, _inherits2["default"])(ServiceHttpResponseError, _ExtensibleError);

  var _super2 = _createSuper(ServiceHttpResponseError);

  function ServiceHttpResponseError(message, response) {
    var _this2;

    var additionalInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    (0, _classCallCheck2["default"])(this, ServiceHttpResponseError);
    _this2 = _super2.call(this, message, additionalInfo);
    _this2.response = response;

    if (response && response.body) {
      if ((0, _typeof2["default"])(response.body) === 'object') {
        _this2.responseMessage = response.body.message;
      } else {
        _this2.responseMessage = response.body;
      }
    }

    return _this2;
  }

  (0, _createClass2["default"])(ServiceHttpResponseError, [{
    key: "toString",
    value: function toString() {
      var _this$responseMessage;

      return "".concat(this.message, " - ").concat(this.response.status, " (").concat(this.response.statusText, ")\n\t").concat((_this$responseMessage = this.responseMessage) !== null && _this$responseMessage !== void 0 ? _this$responseMessage : '');
    }
  }]);
  return ServiceHttpResponseError;
}(ExtensibleError);

exports.ServiceHttpResponseError = ServiceHttpResponseError;

var buildOptions = function buildOptions() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'GET';
  var body = arguments.length > 1 ? arguments[1] : undefined;
  var additionalHeaders = arguments.length > 2 ? arguments[2] : undefined;
  var accessToken = arguments.length > 3 ? arguments[3] : undefined;

  var headers = _objectSpread({
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken)
  }, additionalHeaders);

  if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
    headers['Content-Type'] = 'application/json';
  }

  if (body && typeof body !== 'string') {
    // eslint-disable-next-line no-param-reassign
    body = JSON.stringify(body);
  }

  return {
    method: method,
    mode: 'cors',
    headers: headers,
    body: body
  };
};

exports.buildOptions = buildOptions;

var checkResponse = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(res, serviceComment, isSimpleResponse) {
    var body, response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!res.ok) {
              _context.next = 7;
              break;
            }

            if (!(res.status === 204)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", isSimpleResponse ? null : {
              response: res
            });

          case 3:
            _context.next = 5;
            return res.json();

          case 5:
            body = _context.sent;
            return _context.abrupt("return", isSimpleResponse ? body : {
              response: res,
              body: body
            });

          case 7:
            response = {
              status: res.status,
              statusText: res.statusText,
              ok: res.ok
            };
            _context.next = 10;
            return /application\/json/.test(res.headers.get('content-type')) ? res.json() : res.text();

          case 10:
            response.body = _context.sent;
            throw new ServiceHttpResponseError("Error fetching ".concat(serviceComment), response);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function checkResponse(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.checkResponse = checkResponse;